import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "tw-mt-[50px]"
}
const _hoisted_2 = { key: 0 }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "sentence" }, " Congratulations you completed this activity. You can choose to practice the words again or test yourself. ", -1)
const _hoisted_4 = { class: "final-spelling-points" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h3", null, "Test results have been saved successfully", -1)
const _hoisted_6 = { key: 0 }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("p", null, "You got all your spellings correct first time.", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("p", null, "You have earned 50 extra Spelling Points.", -1)
const _hoisted_9 = [
  _hoisted_7,
  _hoisted_8
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_ctx.status > 1)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (_ctx.mode == 'practice')
          ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("div", _hoisted_4, " You scored " + _toDisplayString(_ctx.spellingPoints) + " Spelling Points ", 1),
              _createElementVNode("div", null, [
                _createElementVNode("button", {
                  class: "sf-btn-primary",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.$emit('close')), ["prevent"]))
                }, " Close ")
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", null, [
          (_ctx.status == 2)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _hoisted_5,
                (_ctx.isPerfectScore)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, _hoisted_9))
                  : _createCommentVNode("", true)
              ], 64))
            : (_ctx.status == 3)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(" You scored " + _toDisplayString(_ctx.spellingPoints) + " Spelling Points ", 1)
                ], 64))
              : _createCommentVNode("", true),
          _createElementVNode("div", null, [
            _createElementVNode("button", {
              type: "button",
              class: "sf-btn-primary",
              onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.$emit('showresults')), ["prevent"]))
            }, " Show Results ")
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}